<template>
  <!-- File upload dialog -->
  <!-- TODO esc and enter should be common across all dialogs -->
  <v-dialog
    value="true"
    persistent
    max-width="500px"
    scrollable
    @keydown.esc="close"
    @keyup.enter="uploadActionClick"
  >
    <v-card>
      <v-card-title> Upload External Document </v-card-title>
      <v-card-text>
        <!-- if account === OpenLaw, alert and prevent like New Documents -->
        <!-- TODO this should be a common component -->
        <v-alert
          v-if="isOpenLaw"
          :value="true"
          class="white"
          outlined
          type="info"
        >
          You're logged in as an Administrator with 'OpenLaw' as the selected
          account. Go to
          <router-link to="/oladmin/accounts">
            Accounts<!--
           -->
          </router-link>
          to select another account.
        </v-alert>

        <v-form
          v-else
          ref="uploadFileForm"
          v-model="docDetailsValid"
        >
          <file-input
            label="File*"
            required
            :accept="uploadAcceptExtensions"
            :rules="[
              validateRequiredFile,
              validateFileMimeType
            ]"
            @change="(files) => filesChange(files)"
          />
          <!-- TODO readonly and disabled should be if not New doc. -->

          <v-text-field
            v-model="docName"
            :rules="[validateRequired]"
            label="Document Name*"
            required
          />

          <document-type-select v-model="documentType" />

          <v-text-field
            v-model="counterpartyName"
            :rules="[validateRequired]"
            label="Counterparty Name*"
            required
          />

          <v-text-field
            v-model="docDate"
            :rules="[validateRequired]"
            label="What date was the document signed?"
            type="date"
            required
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="uploading"
          small
          text
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          v-if="!uploading"
          :disabled="!docDetailsValid"
          small
          color="primary"
          @click="uploadActionClick"
        >
          Upload
        </v-btn>
        <v-btn
          v-else
          :disabled="uploading"
          small
        >
          <v-progress-circular v-model="uploadProgress" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { uploadAcceptExtensions } from '@/utils/mimeTypes'
import { validateRequired, validateRequiredFile, validateFileMimeType } from '@/utils/validationRules'
import DocumentTypeSelect from './DocumentTypeSelect.vue'

const FileInput = () => import('@/components/utils/OlDragAndDropFileInput')

export default {
  name: 'VaultUploadDialog',
  components: {
    FileInput,
    DocumentTypeSelect
  },
  data: function () {
    return {
      uploadAcceptExtensions,
      files: {},
      uploading: false,
      uploadProgress: 50,
      counterpartyName: null,
      docName: null,
      docDate: null,
      docDetailsValid: false,
      documentType: null
    }
  },
  computed: {
    isOpenLaw() {
      return this.isAdmin && this.account.shortName === 'OpenLaw'
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_account'])

    this.mapStates(['user', 'account'])
    this.mapGetters(['isAdmin'])
  },
  methods: {
    validateRequired,
    validateRequiredFile,
    validateFileMimeType,
    close() {
      this.$emit('close')
    },
    genFormDataFromFiles(files) {
      const forms = []
      for (const file of files) {
        const form = new FormData()
        form.append('data', file, file.name)
        forms.push(form)
      }
      return forms
    },
    async uploadToStorage() {
      this.uploading = true

      const formData = this.genFormDataFromFiles(this.files)[0]
      formData.append('name', this.docName)
      formData.append('documentType', this.documentType)
      formData.append('counterpartyName', this.counterpartyName)
      formData.append('signedDate', this.docDate)

      await this.$handlingError(
        `Error uploading document ${this.docName}`,
        async () => {
          await this.$api.uploadSignedDocument(formData)
          this.$showSuccessbar('Document uploaded.')
          this.close()
        },
        {
          final: () => {
            this.uploading = false
          }
        }
      )
    },
    uploadActionClick() {
      if (this.docDetailsValid) {
        this.uploadToStorage()
      }
    },
    stripExtension(filename) {
      if (!filename) {
        return ''
      }
      return filename.replace(/\.[^/.]+$/, '')
    },
    filesChange(files) {
      // if docName is blank, give it the same name the file, minus the extension
      if (!this.docName && files && files.length) {
        this.docName = this.stripExtension(files[0].name)
      }

      this.files = files
    }
  }
}
</script>
